import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  ThreadListFilters,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListFilters';
import {
  ThreadListMainHeader,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListMainHeader/ThreadListMainHeader';
import {
  ThreadListSubHeader,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader/components/ThreadListSubHeader/ThreadListSubHeader';

const useStyles = buildUseStyles('ThreadListHeaderLayout', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 'initial',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  actionBar: {
    flexShrink: 0,
  },
  actionBarMobile: {
    marginTop: theme.spacing(1),
  },
  actionBarDesktop: {
    marginTop: theme.spacing(1),
  },
}));

const ThreadListHeaderLayout = ({
  className,
  onSubmit,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();

  return (
    <Box className={classNames(classes.root, className)}>
      <ThreadListMainHeader />
      <ThreadListFilters
        className={classNames(classes.actionBar, {
          [classes.actionBarDesktop]: !isMobile,
          [classes.actionBarMobile]: isMobile,
        })}
        onSubmit={onSubmit}
      />
      <ThreadListSubHeader />
    </Box>
  );
};

ThreadListHeaderLayout.defaultProps = {
  className: '',
};

ThreadListHeaderLayout.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

export { ThreadListHeaderLayout };
